module.exports = __webpack_public_path__ + "img/NYC.74f3b932.jpg";